import "@mantine/core/styles.css"
import "@mantine/notifications/styles.css"
import "@agent-todo/shared-ui/theme/styles.css"

import { shadcnCssVariableResolver, shadcnTheme } from "@agent-todo/shared-ui"
import { MantineProvider } from "@mantine/core"
import { Notifications } from "@mantine/notifications"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { RouterProvider } from "@tanstack/react-router"

import { AuthProvider } from "./contexts/AuthContext"
import { useAuth } from "./hooks/useAuth"
import { router } from "./router"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
})

function InnerApp() {
  const auth = useAuth()
  return <RouterProvider router={router} context={{ auth }} />
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={shadcnTheme} cssVariablesResolver={shadcnCssVariableResolver} defaultColorScheme="auto">
        <Notifications position="top-right" />
        <AuthProvider>
          <InnerApp />
        </AuthProvider>
      </MantineProvider>
    </QueryClientProvider>
  )
}

export default App
